export default __webpack_public_path__ + "static/media/tqicon-5.94a9749e.svg";